<button class="btn btn--more" tabindex="0" title="Sluit" modal-close-btn>
    <span>Sluit</span>
    <svg class="svg-icon svg-icon--xs"><use href="assets/icons-ui.svg#cross-closed"></use></svg>
</button>
<div modal-content>
    <div class="text-center">
        <ins-cat [reverse]="true"></ins-cat>
        <p>Een momentje alstublieft, we maken nu uw document</p>
    </div>
</div>
